import { HttpClient } from '@angular/common/http';
import {
  inject,
  Injectable,
} from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
  Candidacy,
  VacancyDetail
} from '../../../../../core/model/vacancies.model';
import { FirebaseFunctions } from '../../app.config';


@Injectable({
  providedIn: 'root',
})
/**
 * Flatchr Service
 */
export class FlatchrService {
  private functions = inject(FirebaseFunctions);
  private http = inject(HttpClient)

  /**
   * Call API to get a payment link
   * @returns The promise
   */
  async list(): Promise<[ VacancyDetail, VacancyDetail[] ]> {
    const vacancies = await lastValueFrom(this.http.get<{
      spontaneousV: VacancyDetail,
      items: { vacancy: VacancyDetail }[]
    }>('https://careers.flatchr.io/company/caliceoholding.json'))
    vacancies.items.forEach(({ vacancy }) => {
      if (vacancy.tags[0]?.title === 'HOLDING') {
        vacancy.tags[0].title = 'LYON';
      }
    })
    return [ vacancies.spontaneousV, vacancies.items.map(v => v.vacancy) ];
  }

  async candidate(candidacy: Candidacy): Promise<void> {
    return this.functions.httpsCallable<Candidacy, void>('flatchr-candidate', candidacy);
  }
}
